




























import BaseComponent from '@/components/BaseComponent';
import { NSPTableSettings } from '@/components/Table/typing/table-settings';
import { miscTypes } from '@/store/modules/misc/miscTypes';
import MaterialIcon from '@/typing/enums/materialIcon.enum';
import Component from 'vue-class-component';
import NSPTable from '@/components/Table/NSPTable.vue';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import DateInput from '@/components/DateInput/DateInput.vue';
import Button from '@/components/Button/Button.vue';
import Modal from '@/components/Modal/Modal.vue';
import { INSPTableEvent } from '@/components/Table/typing/table-event.interface';
import { PostPutProject } from '@/typing/api/postProject.class';
import { Project } from '@/typing/api/project.class';
import { Contractor } from '@/typing/api/contractor.class';
import { Report } from '@/typing/api/report.class';
import { Trip } from '@/typing/api/tripNew.class';
import { TripStatus } from '@/typing/enums/tripStatus.enum';

@Component({
  components: {
    NSPTable,
    Button,
    Modal,
    Dropdown,
    DateInput,
  },
})
export default class ProjectOverview extends BaseComponent {
  tSettings = new NSPTableSettings();
  showAddProjectModal = false;
  newProject = new PostPutProject();
  submittedProjectOnce = false;
  toCloseProject: Project | null = null;
  reportFilterTerm = '';

  get contractorItems(): any[] {
    const contractors = this.$state.project.projectData?.contractors;
    if (!contractors) return [];
    return contractors.map((c: Contractor) => {
      return { label: c.name, value: c.id };
    });
  }

  get shownReports(): Project[] {
    const projectData = this.$state.project.projectData;
    const reports = [...(this.$state.project.projectData?.reports ?? [])];

    if (this.reportFilterTerm.trim().length > 0) {
      return reports.filter((r: Report) => {
        const project = projectData?.getProjectById(r.projectId);
        const shipName = projectData?.getShipById(r.shipId)?.name;
        const searchString = `(${project?.name ?? ''} ${
          project?.description ?? ''
        } ${project?.number ?? ''} ${shipName ?? ''})`;

        return searchString
          .toLowerCase()
          .includes(this.reportFilterTerm.toLowerCase());
      });
    }

    return reports;
  }

  mounted(): void {
    this._genericInit(true);
    this._setPageName('Rapporten');

    if (this.isClient() || this.isContractor()) {
      if (this.isClient()) {
        this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
          label: 'Projecten',
          active: false,
          navPath: '/projects',
        });
      }
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Rapporten',
        active: true,
        navPath: '/reports',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Exporteren',
        active: false,
        navPath: '/export',
      });
      if (this.isClient()) {
        this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Beheer',
        active: false,
        navPath: '/manage',
      });
      }
    }

    this.tSettings
      .addColumn({
        label: 'Project',
        valueKey: 'projectId',
        formatFn: (val: any) => {
          return (
            this.$state.project.projectData?.getProjectById(val)?.name ?? val
          );
        },
      })
      .addColumn({
        label: 'Projectnummer',
        valueKey: 'projectId',
        formatFn: (val: any) => {
          return (
            this.$state.project.projectData?.getProjectById(val)?.number ?? val
          );
        },
      })
      .addColumn({
        label: 'Omschrijving',
        valueKey: 'projectId',
        formatFn: (val: any) => {
          let description: string =
            this.$state.project.projectData?.getProjectById(val)?.description ??
            val.toString();

          if (description.length > 70) {
            return `${description.substring(0, 67)}...`;
          }

          return description;
        },
      })
      .addColumn({
        label: 'Scheepsnaam',
        valueKey: 'shipId',
        formatFn: (val: any) => {
          return this.$state.project.projectData?.getShipById(val)?.name ?? val;
        },
      })
      .addColumn({
        label: 'Reizen',
        valueKey: 'trips',
        formatFn: (val: Trip[]) => val.length,
      })
      .addAction({
        iconName: MaterialIcon.Visibility,
        isAvailable: () => true,
        id: 'view',
      });

    if (this.isSkipper()) {
      this.tSettings
        .addColumn({
          label: 'Niet ingeleverde reizen',
          valueKey: 'trips',
          formatFn: (val: Trip[]) => {
            return val.filter((t: Trip) => t.status === TripStatus.OpenSkipper)
              .length;
          },
        })
        .addColumn({
          label: 'Afgekeurde reizen',
          valueKey: 'trips',
          formatFn: (val: Trip[]) => {
            return val.filter(
              (t: Trip) => t.status === TripStatus.RejectedContractor
            ).length;
          },
        });
    }

    if (this.isContractor() || this.isClient()) {
      this.tSettings.addColumn({
        label: 'Reizen te beoordelen',
        valueKey: 'trips',
        formatFn: (val: Trip[]) => {
          const statusToCountFilterFn = this.isClient()
            ? (t: Trip) => t.status === TripStatus.OpenClient
            : (t: Trip) =>
                t.status === TripStatus.OpenContractor ||
                t.status === TripStatus.RejectedClient;
          return val.filter(statusToCountFilterFn).length;
        },
      });
    }
  }

  handleTableEvent(e: INSPTableEvent): void {
    if (e.actionID === 'view') {
      this.$router.push({
        path: `/project/${e.item.projectId}/report/${e.item.shipId}`,
      });
    }
  }
}
